<template>
    <div class="districts">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="">İl Seçin</label>
                    <select class="form-control custom-input" v-model="city" @change="cityFilter">
                        <option v-for="city in cities" :key="city.id" :value="city.id">{{ city.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>İlçe</th>
                                        <th>Bağlı Olduğu İl</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.city.name }}</td>
                                        <td>
                                            <router-link :to="{ name: 'districts.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs" @click="deleteItem(item.id)">Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                icon: 'fa fa-bank',
                tableName: 'İlçeler Tablosu',
                tableDesc: 'Bu tablo sitenizde aktif/pasif olan İlleri gösterir',
                api: 'districts/',
                items: [],
                cities: [],
                city: '1',
                search: '',
            }
        },
        created () {
            this.getData()
        },
        methods: {
            getData() {
                this.axios.get(this.api)
                    .then(response => {
                        this.items = response.data.districts
                        this.cities = response.data.cities
                    })
            },
            deleteItem(id) {
                this.$swal({
                    title: "Silmek istediğinizden emin misiniz?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Evet",
                    cancelButtonText: "İptal"
                }).then((res) => {
                    if (!res.value) return
                    this.$Progress.start()
                    this.axios.delete(this.api + id).then(res => {
                        this.$Progress.finish()
                        if(res.status == 200) {
                            this.$swal("Başarılı", "İlçe silme işlemi başarılı", "success");
                            this.items = this.items.filter(item => item.id !== id)
                        }
                    }).catch(() => {
                        this.$Progress.fail()
                        this.$swal("Başarısız", "İlçe silme işlemi başarısız", "error");
                    })
                })
            },
            cityFilter() {
                this.$Progress.start()
                this.axios.get(this.api, { params: {
                    city: this.city,
                }}).then(response => {
                    this.items = response.data.districts
                    this.$Progress.finish()
                })
            }
        },
    }
</script>

<style scoped>

</style>